import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSidebarStore } from '@/stores/sidebar';

interface SidebarToggleProps {
  className?: string;
}

// Botón de colapso/expansión del sidebar. El icono cambia según el estado.
export const SidebarToggle = ({ className }: SidebarToggleProps) => {
  const collapsed = useSidebarStore((s) => s.collapsed);
  const toggle = useSidebarStore((s) => s.toggle);

  const Icon = collapsed ? ChevronRight : ChevronLeft;
  const label = collapsed ? 'Expandir sidebar' : 'Colapsar sidebar';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={cn(
        'border-border bg-surface text-text hover:bg-surface-2 focus-visible:ring-ring inline-flex h-8 w-8 items-center justify-center rounded-md border transition-colors focus-visible:ring-2 focus-visible:outline-hidden',
        className,
      )}
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
    </button>
  );
};
